(function () {
  function initSparkles() {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const cursorDot = document.getElementById("cursor-dot");

    // Intensity controls
    const MAX_SPARKLES = 500;
    const DESKTOP_SPARKLES_PER_MOVE = 5;
    const MOBILE_SPARKLES_PER_MOVE = 4;
    const SPARKLES_PER_TAP = 10;

    if (!isMobile && !cursorDot) return;

    // -------------------------
    // DESKTOP (smooth trail)
    // -------------------------
    if (!isMobile && cursorDot) {
      document.addEventListener("pointermove", (e) => {
        const x = e.clientX;
        const y = e.clientY;

        cursorDot.style.left = x + "px";
        cursorDot.style.top = y + "px";

        spawnBurst(x, y, DESKTOP_SPARKLES_PER_MOVE);
      });

      document.addEventListener("click", (e) => {
        spawnBurst(e.clientX, e.clientY, SPARKLES_PER_TAP);
      });
    }

    // -------------------------
    // MOBILE (tap + drag)
    // -------------------------
    if (isMobile) {
      document.addEventListener(
        "touchstart",
        (e) => {
          const t = e.touches?.[0];
          if (!t) return;
          spawnBurst(t.clientX, t.clientY, SPARKLES_PER_TAP);
        },
        { passive: true }
      );

      document.addEventListener(
        "touchmove",
        (e) => {
          const t = e.touches?.[0];
          if (!t) return;
          spawnBurst(t.clientX, t.clientY, MOBILE_SPARKLES_PER_MOVE);
        },
        { passive: true }
      );
    }

    // -------------------------
    // Core sparkle logic
    // -------------------------
    function spawnBurst(x, y, count) {
      for (let i = 0; i < count; i++) {
        // NARROW OFFSET → tighter trail
        const offsetX = (Math.random() - 0.5) * 6;   // was 10
        const offsetY = (Math.random() - 0.5) * 6;   // was 10
        createSparkle(x + offsetX, y + offsetY);
      }
    }

    function createSparkle(x, y) {
      const sparkle = document.createElement("div");
      sparkle.classList.add("sparkle");

      // SHAPE: 50% circles, 50% stars
      const shapeRoll = Math.random();
      let shapeType;

      if (shapeRoll < 0.6) {
        sparkle.classList.add("sparkle--circle");
        shapeType = "circle";
      } else {
        sparkle.classList.add("sparkle--star");
        shapeType = "star";

        // STAR COLORS
        const colorRoll = Math.random();
        if (colorRoll < 0.25) sparkle.classList.add("sparkle--gold");
        else if (colorRoll < 0.5) sparkle.classList.add("sparkle--pink");
        else if (colorRoll < 0.75) sparkle.classList.add("sparkle--blue");
        else sparkle.classList.add("sparkle--purple");
      }

      sparkle.style.left = x + "px";
      sparkle.style.top = y + "px";

      // NARROW TRAIL DRIFT — this is the magic ✨
      const angle = Math.random() * Math.PI * 2;
      const startDist = Math.random() * 2;      // was 4
      const endDist = 10 + Math.random() * 18;  // was 16–40

      sparkle.style.setProperty("--dx", Math.cos(angle) * startDist + "px");
      sparkle.style.setProperty("--dy", Math.sin(angle) * startDist + "px");
      sparkle.style.setProperty("--dx-end", Math.cos(angle) * endDist + "px");
      sparkle.style.setProperty("--dy-end", Math.sin(angle) * endDist + "px");

      // Size stays the same (looked good)
      const size =
        shapeType === "star"
          ? 9 + Math.random() * 5
          : 3 + Math.random() * 4;

      sparkle.style.width = size + "px";
      sparkle.style.height = size + "px";

      document.body.appendChild(sparkle);

      setTimeout(() => {
        sparkle.remove?.();
      }, 800);

      // Soft cleanup
      const sparkles = document.querySelectorAll(".sparkle");
      if (sparkles.length > MAX_SPARKLES) {
        for (let i = 0; i < 15; i++) {
          sparkles[i]?.remove?.();
        }
      }
    }
  }

  // Run after DOM fully loads
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSparkles);
  } else {
    initSparkles();
  }
})();
